import { makeRequest } from 'utils/requestLogger';

const success = (response, commentID) => {
  console.log(commentID);
  console.log('pin Comment. mutation was deleted in clean up');
};

// When the request fails
const failed = (error) => {
  console.log('pin submission failed', error);
};

export default (commentID) => {
  makeRequest('put', `/api/comments/${commentID}/toggle-pin`)
    .then((res) => {
      success(res.data, commentID);
    })
    .catch((error) => {
      failed(error);
    });
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/pinComment.js